/**
 * Static dashboard configuration.
 *
 * The coordinator pubkey and relay set are the single source of truth for what
 * this dashboard subscribes to. Change them here to point the dashboard at a
 * different coordinator or relay topology.
 */

/** Coordinator pubkey (hex) whose CI events this dashboard renders. */
export const COORDINATOR_PUBKEY =
  '765cd47badcbbc4a38c7d0c57d5607663b484c20cd59773f9f7064487f9431e8';

/** Relays to subscribe to for CI events. */
export const RELAYS: string[] = ['wss://relay.ngit.dev', 'wss://gitnostr.com'];

/** Repository address (NIP-34 `a` tag) this dashboard focuses on. */
export const REPO_ADDRESS = '30617:bbbb4701badcbbc4a38c7d0c57d5607663b484c20cd59773f9f7064487f9431e8:ngit-ci-dashboard';

/** How long to keep a run in the in-memory store before pruning (ms). */
export const RUN_RETENTION_MS = 30 * 60 * 1000;
